<template lang="pug">
  v-form(autocomplete='false' v-model='formulario_validado')
    v-col
      v-autocomplete( 
        v-model="Datos.id_motivo" 
        :items="modelo == 'Inputs' ? inputRecord : outputRecord"  
        @change="Datos.warehouse = null;" 
        item-text='name' 
        item-value='key' 
        label='Motivo' 
        :rules='[Rules.required]'
      )

      v-autocomplete(
        v-if='modelo!="Inputs"' 
        chips 
        :multiple='modelo === "Outputs"' 
        v-model='Datos.warehouse' label='Almacén' 
        :items='warehouseRecord' item-text='name' 
        return-object :rules='[Rules.required]'
      )
        template(v-slot:selection='Datos')
          v-chip.v-chip--select-multi(
            :key='JSON.stringify(Datos.item.name)' 
            :input-value='Datos.selected' 
            @input='Datos.parent.selectItem(Datos.item.name)'
          )
            strong {{ Datos.item.name }} 
            small.ml-1(v-if='Datos.item.type')  ({{ Datos.item.type}})
      

</template>
<script>
  import {mapGetters, mapState} from 'vuex'
  export default {
    data:()=>({
      formulario_validado: false,
    
    }),
    props:{
      modelo: String
    },
    watch: {
      'Datos.id_motivo'(){
        let record = (this.modelo == 'Inputs' ? this.inputRecord : this.outputRecord)
        let registro = record.filter( ( {key} ) => key == this.Datos.id_motivo)[0]
        if(!registro) return
        this.Datos.motivo_de_traslado = registro.code
        this.Datos.nombre_motivo_de_traslado = registro.name
      },
      'Datos.warehouse'(){
        let { warehouse } = this.Datos
        if ( this.modelo == 'Inputs' || !warehouse || !warehouse[0]) return 
        this.Datos.punto_de_partida_direccion = warehouse[0].direcciones[0].ubicación
        this.Datos.punto_de_partida_ubigeo = warehouse[0].direcciones[0].ubigeo
      },

    },
    computed:{
      ...mapGetters({
        warehouseRecord: 'Warehouse/record',
        operationsRecord: 'Operations/record',
        outputRecord: 'Operations/outputRecord',
        inputRecord: 'Operations/inputRecord',
      }),
      Modelo() { return this.$store.state[this.modelo] },
      Datos() { return this.$store.state[this.modelo].data },
      Rules() { return this.$store.state.Helpers.rules}
    }
  }
</script>

